import { createRouter, createWebHistory } from "vue-router";
import OfferList from "./views/offers/List.vue";
import Layout from "./components/Layout.vue";
import Login from "./views/Login.vue";
import { useAuthStore } from "./stores/auth";

const withPrefix = (prefix, routes) =>
	routes.map((route) => ({
		...route,
		path: prefix + route.path,
	}));

const router = createRouter({
	history: createWebHistory(import.meta.env.BASE_URL),
	routes: [
		{
			path: "/",
			name: "login",
			component: Login,
		},
		{ path: "/reports/statistics", redirect: { name: "statistics" } },
		{ path: "/reports/conversions", redirect: { name: "conversions" } },
		{ path: "/reports/events", redirect: { name: "events" } },
		{ path: "/reports/rejected", redirect: { name: "rejected" } },
		{ path: "/reports/postback-log", redirect: { name: "postback-log" } },
		{ path: "/reports/external-cost-data", redirect: { name: "external-cost-data" } },
		{ path: "/offers", redirect: { name: "offer-list" } },
		{ path: "/offers/view/:id", redirect: (to) => ({ name: "offer-view", params: { id: to.params.id } }) },
		{
			path: "/app",
			component: Layout,
			children: [
				{
					path: "",
					redirect: () => {
						const user = useAuthStore().user;
						if (user?.type === "advertiser" || (user?.type === "admin" && user.advertiser_id)) {
							return { name: "dashboard" };
						}
						return { name: "statistics" };
					},
				},
				{
					path: "offers",
					redirect: { name: "offer-list" },
				},
				{
					path: "offers/view/:id",
					redirect: (to) => ({ name: "offer-view", params: { id: to.params.id } }),
				},
				{
					path: "reports/statistics",
					redirect: { name: "statistics" },
				},
				{
					path: "reports/conversions",
					redirect: { name: "conversions" },
				},
				{
					path: "reports/events",
					redirect: { name: "events" },
				},
				{
					path: "reports/rejected",
					redirect: { name: "rejected" },
				},
				{
					path: "reports/postback-log",
					redirect: { name: "postback-log" },
				},
				{
					path: "reports/external-cost-data",
					redirect: { name: "external-cost-data" },
				},
				{
					path: "dashboard",
					name: "dashboard",
					component: () => import("./views/reports/DashboardPage.vue"),
				},
				{
					path: "dashboard/edit",
					name: "dashboard-edit",
					component: () => import("./views/reports/DashboardBuilderPage.vue"),
				},
				{
					path: "publisher-payments",
					name: "publisher-payments",
					component: () => import("./views/PublisherPayments.vue"),
				},
				{
					path: "publisher-settings",
					name: "publisher-settings",
					component: () => import("./views/PublisherSettings.vue"),
				},
				{
					path: "profile",
					name: "profile",
					component: () => import("./views/Profile.vue"),
				},
				{
					path: "api",
					name: "api",
					component: () => import("./views/API.vue"),
				},
				{
					path: "advertiser-api",
					name: "advertiser-api",
					component: () => import("./views/AdvertiserAPI.vue"),
				},
				...withPrefix("offers", [
					{
						name: "offer-list",
						path: "",
						component: OfferList,
					},
					{
						name: "offer-view",
						path: "/view/:id",
						component: () => import("./views/offers/View.vue"),
					},
				]),
				...withPrefix("reports", [
					{
						name: "statistics",
						path: "/statistics",
						component: () => import("./views/reports/Statistics.vue"),
					},
					{
						name: "conversions",
						path: "/conversions",
						component: () => import("./views/reports/Conversions.vue"),
					},
					{
						name: "events",
						path: "/events",
						component: () => import("./views/reports/Events.vue"),
					},
					{
						name: "rejected",
						path: "/rejected",
						component: () => import("./views/reports/Rejected.vue"),
					},
					{
						name: "postback-log",
						path: "/postback-log",
						component: () => import("./views/reports/PostbackLog.vue"),
					},
					{
						name: "external-cost-data",
						path: "/external-cost-data",
						component: () => import("./views/reports/ExternalCostDataReports.vue"),
					},
				]),
			],
		},
	],
});

export default router;
